<template>
    <div class="step-panel">
        <ul>
            <li
                :key="step.id"
                v-for="(step, i) in steps"
                :style="{ width: barPieseWidth}"
                class="step-panel-item"
                :class="[{'passed-steps' : i <= activeStepIndex},step.validClass && step.validClass]"
                @click="goToStep(i)"
            >
                    <span>{{i+1}}</span>
                <i class="ico-next"></i>
            </li>
        </ul>
        <span class="step-stat">{{activeStepIndex+1}}{{textStat}} {{steps.length}}</span>
    </div>
</template>


<script>
 export default{
     data : function () {
       return {
           textStat : this.$text.stepStat
       }
     },
     props : ['steps', 'activeStepIndex'],
     computed : {
         barPieseWidth(){
             return 100 / this.steps.length + '%'
         }

     },
     methods:{
         goToStep(i){

             //validate step criterion values
             if(this.$store.getters.getActiveStepIndex < i){
                 if(!this.$store.getters.getUnvalidateCriteria(i-1).length){
                     this.$store.commit('setActiveStepByIndex',i);
                     this.$store.commit('setStepValidClass', 'valid');
                 }
             }else{
                 this.$store.commit('setActiveStepByIndex',i);
             }
         }
     }
 }
</script>


<style scoped>
    .step-stat{
        font-size: 13px;
        vertical-align: top;
        display: inline-block;
        position: relative;top:-3px;
        width: 10%;
        text-align: right;
    }
    ul{
        padding: 0;
        margin: 0;
        width: 90%;
        display: inline-block;
        border-radius: 12px;
    }
    li{
        display: inline-block;
        height: 12px;
        vertical-align: top;
        background:  linear-gradient(-45deg,
        rgba(255, 255, 255, 0.15) 25%,transparent 25%,
        transparent 50%, rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,transparent 75%)
        left/30px 30px repeat-x,
        linear-gradient(to right, #cfd3d2 0%, #cfd3d2 50%, #cfd3d2 100%) left/var(--p,100%) fixed,
        #dadfdd;
        margin-bottom: 6px;
        text-align: center;
        position: relative;
    }


    .calc-tertiary-color li{
        height: 6px;
        background:#EAEAEA;
    }
    .calc-tertiary-color li:before{
        content: '';
        width:12px;
        height: 12px;
        display: block;
        position: absolute;
        top:50%;
        margin-top: -6px;
        border-radius: 50%;
        background: #F8F8F8;
        box-shadow: 0 3px 4px rgba(0, 0, 0, 0.15);
    }

    .calc-tertiary-color li .ico-next{
        display: block;
        border-top: 1px solid #FD5402;
        border-right: 1px solid #FD5402;
        position: absolute;
        top:1px;
        left: 3px;
        z-index: 1;
        width:4px;
        height: 4px;
        transform: rotate(45deg);
    }

    li.step-has-errors,
    li.step-has-errors.passed-steps
    {
        background: #bf0202f7;
    }
    li:first-of-type{
        border-radius: 9px 0 0 9px;
    }
    li:last-of-type{
        border-radius: 0 9px 9px 0;
    }
    li.passed-steps{
        background: var(--panel-passed);
    }
    li:hover, li.active{
        cursor: pointer;
        position: relative;
        background:  linear-gradient(-45deg,
        rgba(255, 255, 255, 0.15) 25%,transparent 25%,
        transparent 50%, rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,transparent 75%)
        left/30px 30px repeat-x,
        linear-gradient(to right, var(--panel-color-1) 0%, var(--panel-color-2) 50%, #cfd3d2 100%) left/var(--p,100%) fixed,
        #dadfdd;
    }

    li span{
        display: none;
        position: absolute;
        top: -30px;
        left: 50%;
        margin-left: -15px;
        background: var(--panel-color-1);
        width: 25px;
        height: 25px;
        border-radius: 50%;
        color:#fff;
        text-align: center;
        font:600 14px/25px sans serif;
    }
    li:hover span, li.active span{
        display: block;
    }

    @media (max-width: 1100px) {
        .step-stat, ul{width: 100%;text-align: center}
    }

</style>